import { createSlice } from '@reduxjs/toolkit'
import { getSiteText } from 'features/shared/SiteUrlLink'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { isEqual } from 'lodash'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  siteSetting: {},
  keywords: [], // {id, text, landingUrl}
  form: {
    isIndividual: false,
    unifiedURL: '',
    pcURL: '',
    mobileURL: '',
  },
  preview: {
    isIndividual: false,
    unifiedURL: '',
    pcURL: '',
    mobileURL: '',
  },
}

export const editKeywordLandingUrl = createAxiosThunk(
  'dashboard/keywordLandingUrlEditModal/editKeywordLandingUrl',
  commands => api.dashboard.modifyLandingURL(commands)
)

const keywordLandingUrlEditModalSlice = createSlice({
  name: 'dashboard/keywordLandingUrlEditModal',
  initialState,

  reducers: {
    showKeywordLandingUrlEdit: (
      state,
      { payload: { keywords, siteSetting } }
    ) => {
      state.siteSetting = siteSetting
      state.keywords = keywords
      const hasSameValue =
        keywords.length > 1 &&
        keywords.every((value, index, array) => {
          const { landingUrl } = value
          const other = array[0].landingUrl
          return isEqual(landingUrl, other)
        })
      if (keywords.length === 1 || hasSameValue) {
        const [first] = keywords
        const { landingUrl } = first
        if (landingUrl) {
          const { individualSettingYn, pcLandingUrl, mobileLandingUrl } =
            landingUrl
          const isIndividual = individualSettingYn === 'Y'
          if (isIndividual) {
            if (pcLandingUrl) {
              state.form.pcURL = getSiteText(
                pcLandingUrl.protocol,
                pcLandingUrl.url
              )
            }
            if (mobileLandingUrl) {
              state.form.mobileURL = getSiteText(
                mobileLandingUrl.protocol,
                mobileLandingUrl.url
              )
            }
          } else {
            state.form.unifiedURL = getSiteText(
              pcLandingUrl.protocol,
              pcLandingUrl.url
            )
          }
          state.form.isIndividual = isIndividual
        } else {
          state.form.isIndividual = siteSetting.isIndividual
        }
      } else {
        state.form.isIndividual = siteSetting.isIndividual
      }
      state.visible = true
    },
    hideKeywordLandingUrlEdit: () => initialState,
    setIsIndividual: (state, { payload }) => {
      state.form.isIndividual = payload
    },
    setUnifiedURL: (state, { payload }) => {
      state.form.unifiedURL = payload
    },
    setPcURL: (state, { payload }) => {
      state.form.pcURL = payload
    },
    setMobileURL: (state, { payload }) => {
      state.form.mobileURL = payload
    },
    showPreview: (state, { payload }) => {
      state.preview = {
        ...state.form,
        ...payload,
      }
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(editKeywordLandingUrl.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(editKeywordLandingUrl.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(editKeywordLandingUrl.rejected, state => {
      state.isSubmitting = false
    })
  },
})

export default keywordLandingUrlEditModalSlice.reducer
export const {
  showKeywordLandingUrlEdit,
  hideKeywordLandingUrlEdit,
  setIsIndividual,
  showPreview,
  hidePreview,
} = keywordLandingUrlEditModalSlice.actions
